import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'

interface Props {
  label:
    | 'Automatisch'
    | 'Per discipline'
    | 'Beoordeling verplicht'
    | 'Werklijst'
    | 'Doorwerken'
  option?: boolean
  tooltip?: string
}

const labelDict: Record<
  Props['label'],
  {
    true: string
    false: string
  }
> = {
  Automatisch: {
    true: 'Bijlage wordt automatisch geplaatst',
    false: 'Bijlage kan alleen handmatig worden geplaatst',
  },
  'Per discipline': {
    true: 'Deze bijlage wordt voor elke discipline op het project apart aangemaakt',
    false:
      'Deze bijlage wordt één keer op het project geplaatst, niet voor elke discipline apart',
  },
  'Beoordeling verplicht': {
    true: 'Deze bijlage moet beoordeeld worden bij oplevering',
    false: 'Deze bijlage wordt niet beoordeeld maar direct opgeleverd',
  },
  Werklijst: {
    true: 'Voor deze bijlage wordt een tegel op het Dashboard - werklijsten aangemaakt',
    false:
      'Voor deze bijlage wordt geen tegel op het Dashboard - werklijsten aangemaakt',
  },
  Doorwerken: {
    true: 'Na beoordeling kan deze bijlage voortgezet worden door de beoordelende partij',
    // zal eigenlijk niet voorkomen
    false:
      'Na beoordeling kan deze bijlage niet voortgezet worden door de beoordelende partij',
  },
}

export const TemplateOption = ({ label, option, tooltip }: Props) => {
  return (
    <Tooltip title={tooltip ?? labelDict[label][option ? 'true' : 'false']}>
      <Chip
        label={label}
        color={option ? 'success' : 'primary'}
        variant="outlined"
        size="small"
        sx={{
          mb: 1,
          mr: 1,
          ...(!option && {
            color: 'text.disabled',
            borderColor: 'text.disabled',
          }),
        }}
        // disabled={!option}
      />
    </Tooltip>
  )
}
